import React from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, IndianRupee, TrendingUp } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const CollegeCard = ({ college, compact = false }) => {
  return (
    <Link to={`/colleges/${college.slug || college.id}`} className="block bg-white rounded-2xl overflow-hidden border border-slate-200 card-lift group">
      <div className="relative h-40 overflow-hidden">
        <img
          src={college.image}
          alt={college.short}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        <Badge className="absolute top-3 left-3 bg-white text-slate-900 hover:bg-white shadow">
          <TrendingUp className="w-3 h-3 mr-1 text-teal-600" /> Rank #{college.ranking}
        </Badge>
        <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-white/95 backdrop-blur px-2 py-1 rounded-full text-xs font-semibold">
          <Star className="w-3.5 h-3.5 text-amber-500 fill-amber-500" />
          {college.rating}
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-start gap-3">
          <img src={college.logo} alt="logo" className="w-10 h-10 rounded-lg -mt-8 border-2 border-white shadow flex-shrink-0" />
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold text-slate-900 leading-snug line-clamp-2 group-hover:text-teal-700 transition-colors" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {college.short}
            </h3>
            <div className="flex items-center gap-1 text-xs text-slate-500 mt-1">
              <MapPin className="w-3 h-3" /> {college.city}, {college.state}
            </div>
          </div>
        </div>

        {!compact && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {college.courses.slice(0, 3).map((c) => (
              <span key={c} className="text-[10px] px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 border border-teal-100">{c}</span>
            ))}
          </div>
        )}

        <div className="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between">
          <div className="flex items-center text-sm text-slate-700 font-semibold">
            <IndianRupee className="w-3.5 h-3.5" />
            <span>{college.fees.replace('₹', '')}</span>
          </div>
          <span className="text-xs font-semibold text-teal-700 group-hover:text-orange-600 transition-colors">View →</span>
        </div>
      </div>
    </Link>
  );
};

export default CollegeCard;
